import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from "./locales/en.json";
import frTranslations from "./locales/fr.json";

export const SUPPORTED_LANGUAGES = ["en", "fr"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  en: "English",
  fr: "Français",
};

const savedLanguage = localStorage.getItem("i18nextLng");
const validatedSavedLanguage =
  savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage as SupportedLanguage)
    ? (savedLanguage as SupportedLanguage)
    : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      fr: { translation: frTranslations },
    },
    lng: validatedSavedLanguage || undefined,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"],
    },
  });

export function changeLanguage(lang: SupportedLanguage): void {
  i18n.changeLanguage(lang);
  localStorage.setItem("i18nextLng", lang);
  document.documentElement.lang = lang;
}

export function getCurrentLanguage(): SupportedLanguage {
  const current = i18n.language;
  if (SUPPORTED_LANGUAGES.includes(current as SupportedLanguage)) {
    return current as SupportedLanguage;
  }
  const shortCode = current?.split("-")[0];
  if (shortCode && SUPPORTED_LANGUAGES.includes(shortCode as SupportedLanguage)) {
    return shortCode as SupportedLanguage;
  }
  return DEFAULT_LANGUAGE;
}

export default i18n;
